import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ILocationResponse } from '@kcftech/prometheus-client';
import {
    LocationIssuesFilters,
    LocationIssuesQuickFilters,
} from 'pages/Location/issues/LocationIssuesQuickFilters';
import {
    DeskLink,
    HeaderActions,
    HeaderContainer,
    Title,
    VerticalDivider,
} from 'pages/Location/issues/styled';
import { OverviewStatusLozenge } from 'shared/lozenge/OverviewStatusLozenge';
import { getLocationMachineHealthDeskBaseRoute } from 'utils/RouteHelper';

type LocationIssuesHeaderProps = Readonly<{
    location: ILocationResponse;
    filters: LocationIssuesFilters;
    onFiltersChange: (filters: LocationIssuesFilters) => void;
}>;

export function LocationIssuesHeader({
    location,
    filters,
    onFiltersChange,
}: LocationIssuesHeaderProps) {
    return (
        <HeaderContainer>
            <Title>Issues</Title>
            <HeaderActions>
                <LocationIssuesQuickFilters
                    filters={filters}
                    onChange={onFiltersChange}
                />
                <OverviewStatusLozenge>PAST 2 WEEKS</OverviewStatusLozenge>
                <VerticalDivider />
                <DeskLink
                    href={getLocationMachineHealthDeskBaseRoute(location.Id, 'active')}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    See all Issues
                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                </DeskLink>
            </HeaderActions>
        </HeaderContainer>
    );
}
